/**
 * The canonical origin of the public site, on the `www.` host.
 *
 * `bid2board.com` answers 308 and sends every request to
 * `www.bid2board.com`, so www is the host that every canonical link, sitemap
 * entry and `og:url` has to name. Two fallbacks disagreed about that before
 * this file existed: `sitemap.xml` defaulted to www while `blogConstants`
 * defaulted to the apex, and `NEXT_PUBLIC_BASE_URL` is not set in
 * production, so the site listed its URLs under www and then told crawlers
 * the canonical was the apex. A canonical pointing at a host that redirects
 * away is the one that gets ignored, and it was costing every page with a
 * canonical at all.
 *
 * One constant, so the two can no longer drift apart.
 */
export const SITE_ORIGIN =
  process.env.NEXT_PUBLIC_BASE_URL || 'https://www.bid2board.com';

/** The canonical URL of a path, which must start with a slash. */
export const canonicalUrl = (path: string): string => `${SITE_ORIGIN}${path}`;
